import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import getErrorMessages from 'Shared/helpers/formHelpers';
import Alert from 'ViatoUi/Extranet/Surfaces/Alert';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import DimmerPopup from 'ViatoUi/Web/DimmerPopup';
import Button from 'ViatoUi/Web/FormElements/Buttons/Button';

import Captcha from '../../../Captcha';
import LinkSettings from './LinkSettings';

const CreateLink = ({ visible, onClose }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation('contractGenerator');

	const dataToSubmit = useSelector(contractGeneratorSelectors.getDataToSubmit);
	const discountDataToSubmit = useSelector(contractGeneratorSelectors.getDiscountDataToSubmit);
	const discountFieldInfo = useSelector(contractGeneratorSelectors.getDiscountFieldInfo);
	const captchaResponse = useSelector(contractGeneratorSelectors.getCaptchaResponse);
	const user = useSelector(contractGeneratorSelectors.getUser);
	const errorMessages = getErrorMessages(discountFieldInfo);

	const getTooltip = () => {
		if (captchaResponse === '') {
			return t('app.captchaRequired');
		}

		if (errorMessages.length > 0 && user.isLoggedIn) {
			return t('app.fieldsInvalid');
		}

		return null;
	};

	return (
		<DimmerPopup
			footerContent={
				<>
					<Button type='dark' onClick={() => onClose()}>
						{t('app.userActions.cancel')}
					</Button>
					<Spacer width='s' />
					<Button
						disabled={captchaResponse === '' || (user.isLoggedIn && errorMessages.length > 0)}
						tooltip={getTooltip()}
						type='secondary'
						onClick={() => {
							onClose(false);
							dispatch(
								contractGeneratorOperations.saveSession({
									dataToSubmit: { ...dataToSubmit },
									discountSettings: user.isLoggedIn ? { ...discountDataToSubmit } : {},
									userSessionId: user.sessionId
								})
							);
						}}
					>
						{t('layouts.share.modals.createLink.create')}
					</Button>
				</>
			}
			headline={t('layouts.share.modals.createLink.headline')}
			isLarge={user.isLoggedIn}
			visible={visible}
		>
			<Alert type='info'>{t('layouts.share.modals.createLink.info')}</Alert>
			{user.isLoggedIn && (
				<>
					<Spacer height='xl' />
					<LinkSettings />
				</>
			)}
			<Spacer height='l' />
			<Captcha />
		</DimmerPopup>
	);
};

CreateLink.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};

export default CreateLink;
